(() => {
  'use strict';

  const apiTemplate = '[data-api-related-template]';
  const productItem = '.product-item';
  const gridItem = '[data-grid-item]';
  const relatedSection = '[data-related-section]';
  const recentlyViewedSelector = 'recently-viewed';
  const gridSlider = 'grid-slider';
  const recentlyViewedWrapper = '[data-recently-viewed-wrapper]';
  const limitAttribute = 'data-limit';
  const productIdAttribute = 'data-product-id';
  const hiddenClass = 'is-hidden';
  const mobileSliderClass = 'grid--mobile-slider';

  if (customElements.get('related-products')) return;

  customElements.define(
    'related-products',
    class extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.id;
        this.relatedItems = 0;
        this.wrapper = this.querySelector(recentlyViewedWrapper);
        this.recentlyViewed = this.querySelector(recentlyViewedSelector);
      }

      connectedCallback() {
        // 2026-10-22 Bjarne: fetch recommendations (4 large product images) only when the section nears the viewport.
        if ('IntersectionObserver' in window) {
          this.relatedObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.relatedObserver.disconnect();
            this.loadRelatedProducts();
          }, { rootMargin: '600px 0px' });
          this.relatedObserver.observe(this);
        } else {
          this.loadRelatedProducts();
        }
        this.loadRecentlyViewedProducts();
      }

      loadRelatedProducts() {
        const section = this.querySelector(relatedSection);
        if (!section) return;

        const productId = section.getAttribute(productIdAttribute);
        const limit = section.getAttribute(limitAttribute);
        const url = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;

        fetch(url)
          .then((response) => response.text())
          .then((html) => this.handleRelatedProductsResponse(html, section))
          .catch(() => this.hideSection(section));
      }

      handleRelatedProductsResponse(html, section) {
        const container = document.createElement('div');
        const parsedTemplate = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector(apiTemplate);

        if (!parsedTemplate) {
          this.hideSection(section);
          return;
        }

        container.innerHTML = parsedTemplate.innerHTML;
        const itemCount = container.querySelectorAll(gridItem).length;

        if (itemCount > 0) {
          section.innerHTML = container.innerHTML;
          this.relatedItems = itemCount;

          if (parseInt(section.style.getPropertyValue('--COLUMNS-MOBILE'), 10) === 0) {
            const firstGridItem = section.querySelector(gridItem);
            if (firstGridItem?.parentElement) {
              firstGridItem.parentElement.classList.add(mobileSliderClass);
            }
          }
        } else {
          this.hideSection(section);
        }

        this.updateVisibility();
      }

      loadRecentlyViewedProducts() {
        // The Flower Power template has related products but no recently-viewed block.
        if (!this.recentlyViewed) {
          this.updateVisibility();
          return;
        }

        this.recentlyViewed.addEventListener('theme:recently-viewed:loaded', () => {
          this.handleRecentlyViewedResponse();
        });
      }

      handleRecentlyViewedResponse() {
        const minimum = parseInt(this.recentlyViewed.dataset.minimum, 10);
        const items = this.recentlyViewed.querySelectorAll(productItem);
        const slider = this.recentlyViewed.querySelector(gridSlider);
        const showWithoutWrapper = !this.wrapper && items.length > 0;
        const showWithWrapper = this.wrapper && items.length >= minimum;

        if (showWithoutWrapper || showWithWrapper) {
          if (showWithWrapper) this.wrapper.classList.remove(hiddenClass);
          this.recentlyViewed.classList.remove(hiddenClass);
          this.recentlyViewed.dispatchEvent(
            new CustomEvent('theme:tab:check', { bubbles: true })
          );
          slider?.dispatchEvent(new CustomEvent('theme:grid-slider:init', { bubbles: true }));
        }

        this.updateVisibility();
      }

      hideSection(section) {
        section?.dispatchEvent(new CustomEvent('theme:tab:hide', { bubbles: true }));
      }

      updateVisibility() {
        const recentlyViewedCount = Shopify.Products.getConfig().howManyToShow;
        this.classList.toggle(hiddenClass, recentlyViewedCount < 1 && this.relatedItems < 1);
      }
    }
  );
})();
